<template>
  <tr class="account-type-row">
    <td>
      {{ accountType.dropdownLabel }}
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="accountType.administrator ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa"
          :class="accountType.businessPlan ? 'fa-check text-success' : 'fa-times text-danger'">
        </span>
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ accountType.monthlyFee | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ accountType.annualFee | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ accountType.driverCost | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ accountType.maxAccounts }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ accountType.preAuth | to_dollar_amount }}
      </div>
    </td>
    <td>
      <router-link v-if="isFinanceAdmin" class="btn btn-sm btn-primary" :to="'/membership/plans/edit/' + accountType.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-else disabled class="btn btn-sm btn-primary">
        <span class="fa fa-edit fa-fw"></span> Edit
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AccountTypeRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    accountType () {
      return {
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/AccountType.vue